export const MODAL_NAMES = {
  KEYBOARD: 'KEYBOARD',
  MACBOOK_PROCESSOR: 'MACBOOK_PROCESSOR',
  LAPTOP_PROCESSOR: 'LAPTOP_PROCESSOR',
  BUNDLE: 'BUNDLE',
  CARRIERS_COMPATIBILITY: 'CARRIERS_COMPATIBILITY',
  RENEWED_IMPACT: 'RENEWED_IMPACT',
  EXCLUDED_ACCESSORIES: 'EXCLUDED_ACCESSORIES',
  FAQ: 'FAQ',
  MEDIA_VIEWER: 'MEDIA_VIEWER',
  NEW_BATTERY: 'NEW_BATTERY',
  PERKS: 'PERKS',
  PREPAID_PLAN: 'PREPAID_PLAN',
  SERVICE_FEE: 'SERVICE_FEE',
  SIM: 'SIM',
  TECH_SPECS: 'TECH_SPECS',
  REASSURANCE: 'REASSURANCE',
  TRADE_IN: 'TRADE_IN',
  VERIFIED_REFURBISHED: 'VERIFIED_REFURBISHED',
  BOUYGUES: 'BOUYGUES_OFFERS',
  VISIBLE_BY_VERIZON_BENEFITS: 'VISIBLE_BY_VERIZON_BENEFITS',
  VISIBLE_BY_VERIZON_POPUP: 'VISIBLE_BY_VERIZON_POPUP',
  MOBILE_PLAN_FAKE_DOOR: 'MOBILE_PLAN_FAKE_DOOR',
  CONDITION_COMPARISON: 'CONDITION_COMPARISON',
  SELLER_DETAILS: 'SELLER_DETAILS',
  FLASH_SALES: 'FLASH_SALES',
  SELLER_FLASH_SALES: 'SELLER_FLASH_SALES',
  INSTRUCTIONS: 'INSTRUCTIONS',
  OBSOLETE_SOFTWARE: 'OBSOLETE_SOFTWARE',
  OBSOLETE_COMPUTER: 'OBSOLETE_COMPUTER',
  UPGRADE_FOR_LESS: 'UPGRADE_FOR_LESS',
  TELCO_CALCULATOR: 'TELCO_CALCULATOR',
  TRADEIN_AU: 'TRADEIN_AU',
} as const

export const ProductCategory = {
  SMARTPHONE: '2',
  SMARTPHONE_BOX: '583',
  MACBOOK_INTEL: '110',
  MACBOOK_M: '528',
  MACBOOK_M1_BOX: '599',
  MACBOOK_INTEL_BOX: '601',
  AIRPODS: '217',
  IPAD: '5',
  APPLE_WATCH: '170',
  TABLETS: '559',
  GAMING_CONSOLE: '20',
  SMARTWATCH: '158',
  LAPTOP: '11',
  IMAC: '111',
  MAC_MINI: '113',
  MAC_PRO: '114',
  MAC_STUDIO: '567',
}

export const MACBOOKS_CATEGORIES = [
  ProductCategory.MACBOOK_INTEL,
  ProductCategory.MACBOOK_M,
  ProductCategory.MACBOOK_M1_BOX,
  ProductCategory.MACBOOK_INTEL_BOX,
  ProductCategory.IMAC,
  ProductCategory.MAC_MINI,
  ProductCategory.MAC_PRO,
  ProductCategory.MAC_STUDIO,
]

export const VALID_GRADES = [9, 10, 11, 12]

export const CATEGORIES_WITH_UPGRADE = [
  ProductCategory.SMARTPHONE,
  ProductCategory.SMARTWATCH,
  ProductCategory.APPLE_WATCH,
  ProductCategory.TABLETS,
  ProductCategory.IPAD,
]

/**
 * Teleport target of the sticky bars. They are rendered in a deferred RevPortal
 * so it doesn't matter where they are defined in the templates.
 *
 * `<RevPortal />` behaves like a `<ClientOnly />`, it only renders the content
 * on the client-side.
 */
export const STICKY_BARS_PORTAL_TARGET = 'sticky-bar-portal-target'
